import styled from 'styled-components';
import { tokens } from '../../../../public/tokens';

const { colors, typography, globals } = tokens;

export const ModalOverlay = styled.div({
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(29, 29, 29, 0.5)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1050,
});

export const ModalContainer = styled.div({
    position: 'relative',
    backgroundColor: colors.surfaces['container-background'],
    borderRadius: globals['border-radius'],
    border: `1px solid ${colors.surfaces['border-divider']}`,
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.10)',
    maxWidth: '684px',
    alignItems: 'flex-start',
    padding: globals['spacing-7'],
    display: 'flex',
    flexDirection: 'column',
    gap: globals['spacing-5'],

});

export const ModalHeader = styled.div({
    display: 'flex',
    alignItems: 'flex-start',
    flexDirection: 'column',
    alignSelf: 'stretch',
    gap: globals['spacing-3'],
});

export const ModalTitle = styled.div({
    fontSize: typography.fontSize['3xl-24px'],
    fontWeight: typography.fontWeights.bold,
    color: colors.text.primary,
    lineHeight: typography.lineHeights[110],
});

export const CloseButton = styled.button({
    position: 'absolute',
    right: '11.505px',
    top: '7.807px',
    background: 'none',
    border: 'none',
    color: colors.neutral.grey[900],
    fontSize: typography.fontSize['lg-14px'],
    fontWeight: typography.fontWeights.light,
});

export const ModalDescription = styled.p({
     alignSelf: 'stretch',
    color: colors.text.secondary,
    fontSize: typography.fontSize['lg-14px'],
    lineHeight: typography.lineHeights['110'],
});

export const FieldGroup = styled.div({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    alignSelf: 'stretch',
});

export const FieldLabel = styled.label({
    fontSize: typography.fontSize['lg-14px'],
    color: colors.text.primary,
});

export const TogglesRow = styled.div({
    display: 'flex',
    flexWrap: 'wrap',
    alignSelf: 'stretch',
    gap: globals['spacing-6'],
});

export const ToggleContainer = styled.div({
    display: 'flex',
    padding: globals['spacing-3'],
    alignItems: 'center',
    gap: globals['spacing-2'],
    flex: '1 0 0',
    height: '44px',
    borderRadius: globals['border-radius'],
    border: `1px solid ${colors.surfaces['border-divider']}`,
    background: colors.surfaces['page-background'],

    '& > label': {
        flexDirection: 'row-reverse',
        justifyContent: 'space-between',
        alignItems: 'center',
        height: '100%',
        width: '100%',
        paddingTop: '4px',
    },
});

export const ErrorMessage = styled.div({
    alignSelf: 'stretch',
    color: colors.states.alert.default,
    fontSize: typography.fontSize['lg-14px'],
    lineHeight: typography.lineHeights['110'],
});

export const ModalFooter = styled.div({
    display: 'flex',
    alignItems: 'center',
    gap: globals['spacing-3'],
});

export const CancelButton = styled.button({
    display: 'flex',
    height: '35px',
    padding: `${globals['spacing-2']} ${globals['spacing-4']}`,
    justifyContent: 'center',
    alignItems: 'center',
    gap: globals['spacing-1-5'],
    borderRadius: globals['border-radius'],
    background: colors.states.alert.default,
    color: colors.neutral.white,
    border: 'none',
    cursor: 'pointer',
});

export const multiSelectStyles = {
    control: (base, state) => ({
        ...base,
        borderColor: state.isFocused ? colors.states.info.default : colors.surfaces['border-divider'],
        display: 'flex',
        minHeight: globals['spacing-10'],
        padding: `${globals['spacing-1']} ${globals['spacing-1-5']}`,
        alignItems: 'center',
        gap: globals['spacing-1-5'],
        alignSelf: 'stretch',
        borderRadius: globals['border-radius'],
        border: `1px solid ${colors.surfaces['border-divider']}`,
        background: colors.surfaces['container-background'],
        boxShadow: '0 0 0 1px rgba(163, 163, 163, 0.50)',
        ':hover': {
            borderColor: colors.states.info.default,
        },
    }),
    valueContainer: (base) => ({
        ...base,
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        alignContent: 'center',
        padding: 0,
    }),
    indicatorsContainer: (base) => ({
        ...base,
        alignItems: 'center',
    }),
    multiValue: (base) => ({
        ...base,
        display: 'flex',
        minHeight: '25px',
        padding: '3px 5px',
        justifyContent: 'center',
        alignItems: 'center',
        gap: globals['spacing-2-5'],
        borderRadius: globals['border-radius'],
        background: colors.neutral.grey['200'],
    }),
    multiValueLabel: (base) => ({
        ...base,
        color: colors.text.primary,
        fontSize: typography.fontSize['lg-14px'],
        fontWeight: typography.fontWeights.semibold,
    }),
    multiValueRemove: (base) => ({
        ...base,
        color: colors.text.primary,
        fontSize: typography.fontSize['lg-14px'],
        fontWeight: typography.fontWeights.light,
        ':hover': {
            backgroundColor: 'transparent',
            color: colors.text.primary,
        },
    }),
};